import { Link } from "react-router-dom";

import style from "./stylepage/Home.module.css";

import CategoryCard from "./../Component/CategoryCard/CategoryCard";

import FoodStore, {ANTIPASTI, BUN, ROSETTE, WRAP, BABYBINARIO/*, CLASSICI*/, CARNE, VEGINSALATE, CONTORNI, BIBITE, BIRREALLASPINA, COCKTAIL, DOLCI, POLPETTERIAEPOLLO} from "./../FoodStore/FoodStore"


import ImgAntipasti from "./../Resource/category/antipasti.jpg";
import ImgPolpette from "./../Resource/category/polpetteriaepollo.png";
import ImgBun from "./../Resource/category/bun.jpg";
import ImgBabyBinario from "./../Resource/category/santabrarbara.jpg";
import ImgCiabatte from "./../Resource/category/ciabatte.jpg";
import ImgWrap from "./../Resource/category/wrap.jpg";
import ImgCarne from "./../Resource/category/carne.jpg";
import ImgVegInsalate from "./../Resource/category/veginsalate.png";
import ImgContorni from "./../Resource/category/contorni.png";
import ImgBibite  from "./../Resource/category/bibite.png";
import ImgBirreSpina from "./../Resource/category/birrespina.jpg";
import ImgCocktail from "./../Resource/category/cocktail.jpg";
import ImgDolci from "./../Resource/category/dolci.png";

import ImgStatusMenu from "./../Resource/icon/statusMenu.png";

import FoodInLine from "./../Component/FoodList/FoodInLine/FoodInLine";
import FoodCard from "./../Component/FoodList/FoodCard/FoodCard";
import { useRef } from "react";

function Home() {
    const refMenu = useRef();

    function toggleMenu(e : React.MouseEvent, name: string, toggle: boolean = false){
        let menu : HTMLUListElement= refMenu.current;
        menu.childNodes.forEach(i => {
            let item = i as HTMLLIElement;
            !toggle && item.classList.remove(style.openSection);
            if(toggle){
                item.id === name && item.classList.toggle(style.openSection)
            }else{
                item.id === name && item.classList.add(style.openSection)
            }
        })
    }

    return (
        <>
            <p className={style.segnaletica}>Dai panini si possono togliere ingredienti ma non aggiungerli!</p>
            <h2>Menu</h2>
            {/* <div className={style.hiro}>
                
                </div> */
            }

            <div className={style.categoryBox} id="navigation">
                <CategoryCard name="Antipasti" route="#antipasti" img={ImgAntipasti} onClick={e => toggleMenu(e, "antipasti")}/>
                <CategoryCard name="Polpetteria e pollo" route="#polpetteriaepollo" img={ImgPolpette} onClick={e => toggleMenu(e, "polpetteriaepollo")}/>
                <CategoryCard name="Bun" route="#bun" img={ImgBun} onClick={e => toggleMenu(e, "bun")}/>
                <CategoryCard name="Rosette" route="#rosette" img={ImgCiabatte} onClick={e => toggleMenu(e, "rosette")}/>
                <CategoryCard name="Wrap" route="#wrap" img={ImgWrap} onClick={e => toggleMenu(e, "wrap")}/>
                <CategoryCard name="Baby binario" route="#babybinario" img={ImgBabyBinario} onClick={e => toggleMenu(e, "babybinario")}/>
                <CategoryCard name="Carne" route="#carne" img={ImgCarne} onClick={e => toggleMenu(e, "carne")}/>
                <CategoryCard name="Veg Insalate" route="#veginsalate" img={ImgVegInsalate} onClick={e => toggleMenu(e, "veginsalate")}/>
                <CategoryCard name="Contorni" route="#contorni" img={ImgContorni} onClick={e => toggleMenu(e, "contorni")}/>
                <CategoryCard name="Bibite" route="#bibite" img={ImgBibite} onClick={e => toggleMenu(e, "bibite")}/>
                <CategoryCard name="Birre alla spina" route="#birreallaspina" img={ImgBirreSpina} onClick={e => toggleMenu(e, "birreallaspina")}/>
                <CategoryCard name="Cocktail" route="#cocktail" img={ImgCocktail} onClick={e => toggleMenu(e, "cocktail")}/>
                <CategoryCard name="Dolci" route="#dolci" img={ImgDolci} onClick={e => toggleMenu(e, "dolci")}/>
            </div>
            <div>
                <ul className={style.menuBox} id="menuBox" ref={refMenu}>
                    <li id="antipasti" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Antipasti</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "antipasti", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {ANTIPASTI.map((food : FoodStore, index) => <FoodInLine food={food} treno="ANTIPASTO" key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                    <li id="polpetteriaepollo" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>polpetteria e pollo</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "polpetteriaepollo", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {POLPETTERIAEPOLLO.map((food : FoodStore, index) => <FoodInLine food={food} treno="POLPETTERIAEPOLLO" key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                    <li id="bun" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Bun</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "bun", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {BUN.map((food : FoodStore, index) => <FoodCard food={food} key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                    <li id="rosette" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Rosette</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "rosette", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {ROSETTE.map((food : FoodStore, index) => <FoodCard food={food} key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                    <li id="wrap" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Wrap</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "wrap", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {WRAP.map((food : FoodStore, index) => <FoodInLine food={food} treno="WRAP" key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                    <li id="babybinario" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Baby binario</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "babybinario", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {BABYBINARIO.map((food : FoodStore, index) => <FoodInLine food={food} treno="BABYBINARIO" key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                    {/* <li id="classici" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Classici</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "classici", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {CLASSICI.map((food : FoodStore, index) => <FoodInLine food={food} treno="CLASSICI" key={index+"_"+food.name}/>)}
                        </div>
                    </li> */}
                    <li id="carne" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Carne</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "carne", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {CARNE.map((food : FoodStore, index) => <FoodCard food={food} key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                    <li id="veginsalate" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Veg Insalate</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "veginsalate", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {VEGINSALATE.map((food : FoodStore, index) => <FoodInLine food={food} treno="VEG INSALATE" key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                    <li id="contorni" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Contorni</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "contorni", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {CONTORNI.map((food : FoodStore, index) => <FoodInLine food={food} treno="CONTORNI" key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                    <li id="bibite" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Bibite</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "bibite", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {BIBITE.map((food : FoodStore, index) => <FoodInLine food={food} treno="BIBITE" key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                    <li id="birreallaspina" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Birre alla spina</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "birreallaspina", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {BIRREALLASPINA.map((food : FoodStore, index) => <FoodInLine food={food} treno="BIRRE ALLA SPINA" key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                    <li id="cocktail" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Cocktail</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "cocktail", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {COCKTAIL.map((food : FoodStore, index) => <FoodInLine food={food} treno="COCKTAIL" key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                    <li id="dolci" className={style.listBox}>
                        <div className={style.menuCategory}>
                            <p>Dolci</p>
                            <Link to="#navigation" reloadDocument>Vai su</Link>
                            <button onClick={e => toggleMenu(e , "dolci", true)}><img src={ImgStatusMenu} title="mostra/nascondi" alt="icona"/></button>
                        </div>
                        <div className={style.list}>
                            {DOLCI.map((food : FoodStore, index) => <FoodInLine food={food} treno="DOLCI" key={index+"_"+food.name}/>)}
                        </div>
                    </li>
                </ul>
            </div>
        </>
    );
  }
  
  export default Home;